import { FilterDaterangeController } from "./daterange.controller";

angular
    .module("thor.shared.filter.daterange.component", [])
    .component("thorFilterDaterange", {
        bindings: {
            from: "=?",
            to: "=?",
            datetimeRange: "=?"
        },
        controller: FilterDaterangeController,
        template: require("../../shared/filter/daterange.html")
    });
